<template>
    <integration-google-calendar is-onboarding-integration/>
</template>

<script>
import {defineComponent} from 'vue'
import IntegrationGoogleCalendar from "../../settings/integrations/IntegrationGoogleCalendar.vue";

export default defineComponent({
  name: "OnboardingStepGoogleCalendar",
  components: {IntegrationGoogleCalendar},
})
</script>

<style scoped lang="scss">

</style>
